module.exports = {
  devServer: {
    proxy: {
      '^/rse': {
        target: 'http://localhost:8081/',
        ws: true,
        changeOrigin: true
      }
    },
    host: 'localhost'
  }
};
